module.exports = __webpack_public_path__ + "img/IT0004625116841.57108372.png";